import type { SinglePayee } from '@/types/portal';

/**
 * Payees a finance user has saved from the Single Payment success receipt.
 * Only the additions are stored — the fixed directory still comes from the
 * mock module, so platform payees stay up to date while saved ones persist.
 */
const STORAGE_KEY = 'twiva.payeeDirectory.v1';

/** Read the payees the user has saved, newest last. */
export function loadSavedPayees(): SinglePayee[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as SinglePayee[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Persist user-saved payees; degrades quietly if storage is blocked. */
export function persistSavedPayees(payees: SinglePayee[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payees));
  } catch {
    // Storage unavailable (private mode) — the session keeps the in-memory copy.
  }
}

/** Append a payee to a saved set, skipping one that is already present. */
export function appendSavedPayee(
  list: SinglePayee[],
  payee: SinglePayee,
): SinglePayee[] {
  if (list.some((item) => item.id === payee.id)) return list;
  return [...list, payee];
}